import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SplitTotalProps {
    totalPrice: string
}

const SplitTotal: FC<SplitTotalProps> = ({ totalPrice }) => {
    const { t } = useTranslation('app')
    const { styles } = useStyles(stylesheet)

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h4" style={styles.label}>
                {t('openTabs.summary.total')}
            </Typography.Heading>
            <Typography.Heading variant="h4">{totalPrice}</Typography.Heading>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        height: 72,
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 24,
        borderTopWidth: 1,
        borderTopColor: ColorEnum.GRAY_300,
    },
    label: {
        flex: 1,
    },
})

export default SplitTotal
